/* eslint react/prop-types: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  setDisplayName,
  setPropTypes,
  withStateHandlers,
} from 'recompose';
import styles from './Pointer.scss';

export class Pointer extends Component {
  static getDerivedStateFromProps({ calculatePointerPosition }) {
    return calculatePointerPosition();
  }

  render() {
    const { left } = this.props;
    return (
      <div
        className={styles.root}
        style={{ left }}
            />
    );
  }
}

export default compose(
  setDisplayName('Pointer'),
  withStateHandlers(
    ({ initialLeft = 0 }) => ({
      left: initialLeft,
    }),
    {
      calculatePointerPosition(_, { calculatePosition }) {
        return calculatePosition;
      },
    },
  ),
  setPropTypes({
    calculatePointerPosition: PropTypes.func.isRequired,
    left: PropTypes.number.isRequired,
  }),
)(Pointer);
